import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
    Container,
    Typography,
    TextField,
    Table, TableBody, TableRow, TableCell,
} from '@mui/material';
import { GetCookieInfo } from '../../../logic/CookieManager';
import {
    Black,
    StyledButtonOrange,
    StyledButtonContainer,
    StyledTableCell
} from "../../../styles/MyStyles";
import {GetAssetLookupMenuItemsByType, GetLookupMenuItems} from "../../../logic/LookupHelper";

const BankAccountEditPage = () => {
    const { clientId, bankAccountId} = useParams();
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});

    const [bankAccount, setBankAccount] = useState({
        ownerId: clientId ?? process.env.REACT_APP_NEWCENT_CONTACT_ID,
        bankId: '',
        assetId: '',
        iban: ''
    });

    useEffect(() => {
        const fetchBankAccount = async () => {
            try {
                const tokenCookie = GetCookieInfo('nplt');
                if (bankAccountId) {
                    const response = await fetch(
                        `${process.env.REACT_APP_BANK_ACCOUNTS_URL}/single/${bankAccountId}`,
                        {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: 'Bearer ' + tokenCookie.value,
                            },
                        }
                    );
                    if (response.ok) {
                        const data = await response.json();
                        setBankAccount(data.data);
                    } else {
                        console.log('Fetch bank account failed.');
                    }
                } else {
                    setBankAccount({
                        ownerId: clientId ?? process.env.REACT_APP_NEWCENT_CONTACT_ID,
                        bankId: '',
                        assetId: '',
                        iban: ''
                    });
                    console.log(bankAccount);
                }
            } catch (error) {
                console.log('An error occurred:', error);
            }
        };

        fetchBankAccount();
    }, [bankAccountId]);

    const validateForm = () => {
        let newErrors = {};

        if (bankAccount.bankId === '') {
            newErrors.bankId = 'Bank is required.';
        }

        if (bankAccount.assetId === '') {
            newErrors.assetId = 'Asset is required.';
        }

        if (!bankAccount.iban.trim()) {
            newErrors.iban = 'Iabn is required.';
        }

        // Return the errors
        return newErrors;
    };

    const handleFieldChange = (event) => {
        setBankAccount({
            ...bankAccount,
            [event.target.name]: event.target.value,
        });

        //setErrors(validateForm());
    };

    const handleSave = async () => {
        try {
            const newErrors = validateForm();

            if (Object.keys(newErrors).length > 0) {
                setErrors(newErrors);
                return;
            }

            const tokenCookie = GetCookieInfo('nplt');
            const response = await fetch(
                `${process.env.REACT_APP_BANK_ACCOUNTS_URL}`,
                {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + tokenCookie.value,
                    },
                    body: JSON.stringify(bankAccount),
                }
            );
            if (response.ok) {
                console.log('Bank account updated successfully.');
                handleGoBack();
            } else {
                console.log('Update bank account failed.');
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    const handleGoBack = () => {
        navigate(-1);
    };

    return (
        <Container sx={{ margin: '0.2rem', minWidth: '99%' }}>
            <Typography variant="h4" gutterBottom sx={{ color: Black }}>
                {bankAccountId ? 'Edit Bank Account' : 'Create Bank Account'}
            </Typography>
            <StyledButtonContainer container>
                <StyledButtonOrange variant="contained" onClick={handleGoBack}>
                    Back
                </StyledButtonOrange>
                <StyledButtonOrange variant="contained" onClick={handleSave}>
                    Save
                </StyledButtonOrange>
            </StyledButtonContainer>
            <Table>
                <TableBody>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Bank</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="bankId"
                                label="Bank"
                                select
                                value={bankAccount.bankId}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.bankId}
                                helperText={errors.bankId}
                            >
                                {GetLookupMenuItems('bank')}
                            </TextField>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Asset</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="assetId"
                                label="Asset"
                                select
                                value={bankAccount.assetId}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.assetId}
                                helperText={errors.assetId}
                            >
                                {GetAssetLookupMenuItemsByType(0)}
                            </TextField>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Iban</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="iban"
                                label="Iban"
                                value={bankAccount.iban}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.iban}
                                helperText={errors.iban}
                            />
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </Container>
    );
};

export default BankAccountEditPage;
